

const serviceInfo = [
    {
        name: 'Fluoride Treatment',
        description: 'Lorem ipsum is simply dummy text of dummy text of the pri ',
        price: '16',
        image: "https://i.ibb.co/FDfcmRS/Fluoride.png",
    },
    {
        name: 'Cavity Filling',
        description: 'Lorem ipsum is simply dummy text of dummy text of the pri ',
        price: '19',
        image: "https://i.ibb.co/Zdnc2W0/Cavity.png",
    },
    {
        name: 'Teath Whitening',
        description: 'Lorem ipsum is simply dummy text of dummy text of the pri ',
        price: '15',
        image: "https://i.ibb.co/xfnN4Ln/Whitening.png",
    }
]

export default serviceInfo;